import { BrowserRouter,Routes, Route } from "react-router-dom";
import Sidebar from "../src/components/sidebar/side"
import Footer from "./components/footer/footer"
import Crm from "./pages/crm"
import Analytics from "./pages/analytics";
import Salesreportt from "./pages/salesreport";
import Projectreportt from "./pages/projectreport"
import Leadss from "./pages/leads"
import Leadreport from "./pages/leadsreport"
import Login from "../src/components/login/login"
import Register from "../src/components/Register/register"
import Verfiy from "../src/components/verfiy/verfiy"
import Main from "../src/components/maintenance/main"
import Propsal from "./components/proposal/proposal"
import Proposalcreate from "./pages/proposalcreate"
import Propvieww from "./pages/proposalbview"
import Customers from "./pages/customers"
import CustomerCreatee from "./pages/customercreate"
import Customervieww from "./pages/customerview"
import Proj from "./pages/projectss"
import Proposalcreatee from "./pages/projectcreate"
import Help from "./components/helpcenter/help"
import Eror from "../src/components/eror/eror";

function App() {
    return ( 
        <>

        <BrowserRouter>
         <Sidebar/>

        <Routes>
        <Route path="/*" element={<Crm/>} />

        <Route path="/crm" element={<Crm/>} />

         <Route path="/" element={<Crm/>} />
         <Route path="/analytics" element={<Analytics/>} />
        <Route path="/SalesReport" element={<Salesreportt/>} />
        {/* start leads */}
        <Route path="/LeadsReport" element={<Leadreport/>} />
        <Route path="/ProjectReport" element={<Projectreportt/>} />
        <Route path="/Leads" element={<Leadss/>} />
        <Route path="/LeadsCreate" element={<Leadreport/>} />
        {/* start authencation */}
        <Route path="/Login" element={<Login/>} />
        <Route path="/Register" element={<Register/>} />
        <Route path="/Verify-Otp" element={<Verfiy/>} />
        <Route path="/Maintenance" element={<Main/>} />
        {/* start propsal */}
        <Route path="/Proposal" element={<Propsal/>} />
        <Route path="/ProposalView" element={<Propvieww/>} />
        <Route path="/ProposalCreate" element={<Proposalcreate/>} />
        {/* start customer */}
        <Route path="/Customers" element={<Customers/>} />
        <Route path="/CustomersView" element={<Customervieww/>} />
        <Route path="/CustomersCreate" element={<CustomerCreatee/>} />
        {/* start projects */}
         <Route path="/Projects" element={<Proj/>} />
        <Route path="/ProjectsCreate" element={<Proposalcreatee/>} />
        {/* start help center */}
        <Route path="/KnowledgeBase" element={<Help/>} />











        </Routes>
                <Footer/>
        </BrowserRouter>
        </>
     
    );
}

export default App;